import * as React from 'react';
import { Box, InputLabel, MenuItem, FormControl, Select } from '@mui/material';

export default function AximDropdown(props) {
  const [value, setValue] = React.useState('');
  const handleChange = (event) => {
    setValue(event.target.value);

    if (props.handleChange) {
        props.handleChange(event);
    }
  };

  React.useEffect(() => {
    setValue(props.value);
  });

  return (
    <Box>
      <FormControl sx={{ my: 1, marginRight: 1 }} variant="standard">
        <InputLabel sx={{ fontWeight: 500, fontSize: 20 }} id={`${props.id}-label`}>{props.label}</InputLabel>
        <Select
          labelId={`${props.id}-label`}
          id={props.id}
          value={value}
          onChange={handleChange}
          style={{minWidth: props.minWidth ? props.minWidth : "200px", maxWidth: props.maxWidth ? props.maxWidth : "200px"}}
          disabled={props.disabled}
        >
            {props.pairs.map((pair, i) => (
            <MenuItem value={pair.value} key={i}>
                {pair.text ?? pair.value}
            </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}